import request from "@/core/services/request";

export function whiteListNums() {
  return request({
    url: "/api/v1/white/list/nums/",
    method: "get",
  });
}
